import React from "react";
import ToolkitProvider, { Search } from "react-bootstrap-table2-toolkit";
import paginationFactory from "react-bootstrap-table2-paginator";
import BootstrapTable from "react-bootstrap-table-next";
import { options } from "util/reactTableFuncs";
import { Analysis } from "types";
import { Table } from "@avlino-inc/alenza-react";
import styles from "components/dashboard/Dashboard.module.scss";

const AnalysesTable = ({
  analyses,
  rowEvents,
  showSearch,
  showAccount,
  showDescription,
  cardTable,
}: {
  analyses: Analysis[];
  rowEvents: any;
  showSearch: boolean;
  showAccount?: boolean;
  showDescription?: boolean;
  cardTable?: boolean;
}) => {
  const { SearchBar } = Search;
  const columns: Array<Object> = [
    {
      dataField: "name",
      text: "Analysis",
      sort: true,
      headerAlign: "left",
      align: "left",
    },
  ];
  if (showAccount) {
    columns.push({
      dataField: "account_name",
      text: "Account",
      sort: true,
      headerAlign: "left",
      align: "left",
    });
  }
  if (showDescription) {
    columns.push({
      dataField: "description",
      text: "Description",
      headerAlign: "left",
      align: "left",
    });
  }
  let dataSorted =
    analyses &&
    analyses.sort((a: Analysis, b: Analysis) => a.name.localeCompare(b.name));
  if (dataSorted && showDescription) {
    // Limit the description to a certain number of characters
    dataSorted = dataSorted.map((analysis: Analysis) =>
      analysis.description && analysis.description.length > 30
        ? {
            ...analysis,
            description: `${analysis.description.substring(0, 30)}...`,
          }
        : analysis
    );
  }
  return (
    <div>
      {analyses ? (
        <ToolkitProvider
          keyField="id"
          data={dataSorted}
          columns={columns}
          search
        >
          {(props: any) => (
            <>
              {showSearch ? (
                <div className={styles["table__search-container"]}>
                  <SearchBar
                    className={styles["table__search-container__search-bar"]}
                    {...props.searchProps}
                  />
                </div>
              ) : null}
              <div className={Table.classNames.table}>
                {cardTable ? (
                  <BootstrapTable
                    {...props.baseProps}
                    classes="card-table text-center"
                    bordered={false}
                    bootstrap4
                    rowEvents={rowEvents}
                    pagination={paginationFactory(options)}
                  />
                ) : (
                  <BootstrapTable
                    {...props.baseProps}
                    bordered={false}
                    bootstrap4
                    hover
                    condensed
                    rowEvents={rowEvents}
                    pagination={paginationFactory(options)}
                  />
                )}
              </div>
            </>
          )}
        </ToolkitProvider>
      ) : (
        <p>No Analyses Available</p>
      )}
    </div>
  );
};

export default AnalysesTable;
